"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var codeMap = {
  vueError: '101',
  jsError: '102',
  ajaxError: '103',
  resourceError: '104'
};
var _default = codeMap;
exports.default = _default;